import React from 'react';

import subscriptionDecorator from 'subscriptions/decorator';
import { formatMdn } from 'helpers/formatters';

import styles from './index.module.css';
import user_icon from './user_icon.svg';

export const LineItemHeader = ({ subscription, subId }) => {
  if (!subscription) { return null; }

  return (
    <div className={styles.LineItemHeader}>
      <img className={styles.userIcon} src={user_icon} alt="" />
      <span className={styles.name}>
        {subscription.first_name} {subscription.last_name}
      </span>
      <span className={styles.mdn}>
        {!subscription.mdn &&
          <React.Fragment>
            ID: {subId}
          </React.Fragment>
        }
        {formatMdn(subscription.mdn)}
      </span>
    </div>
  )
}

export default subscriptionDecorator(LineItemHeader);
